/// <amd-module name="SuiteCommerce.CookieConsent.Container.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.CookieConsent.Container.View", ["require", "exports", "Backbone", "suitecommerce_cookie_consent_container.tpl", "SuiteCommerce.CookieConsent.Overlay.View", "SuiteCommerce.CookieConsent.Modal.View", "SuiteCommerce.CookieConsent.CookiesHandler", "SuiteCommerce.CookieConsent.Common.Utils", "SuiteCommerce.CookieConsent.Common.CookiesLogger", "SuiteCommerce.CookieConsent.Common.Configuration"], function (require, exports, Backbone_1, template, Overlay_View_1, Modal_View_1, CookiesHandler_1, Utils_1, CookiesLogger_1, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ContainerView = /** @class */ (function (_super) {
        __extends(ContainerView, _super);
        function ContainerView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = template;
            _this.events = {
                'click [data-action="openCookieSettings"]': 'openCookieSettings',
                'click [data-action="saveSettings"]': 'saveSettings',
                'click [data-action="acceptAll"]': 'acceptAllCookies',
                'click [data-action="rejectAll"]': 'rejectAllCookies'
            };
            _this.application = options.container;
            _this.setupNavigationListener();
            if (!CookiesHandler_1.CookiesHandler.getCookies()) {
                _this.setupCookieLogger();
            }
            return _this;
        }
        Object.defineProperty(ContainerView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'cookieConsent-overlay': function () {
                        if (!CookiesHandler_1.CookiesHandler.getCookies() &&
                            !Utils_1.Utils.isTheCookiePolicyPageOpen()) {
                            _this.overlayView = new Overlay_View_1.OverlayView({ container: _this.application });
                            _this.showBackDrop();
                            return _this.overlayView;
                        }
                    },
                    'cookieConsent-modal': function () {
                        return new Modal_View_1.ModalView({ model: _this.model });
                    }
                };
            },
            enumerable: true,
            configurable: true
        });
        ContainerView.prototype.setupCookieLogger = function () {
            this.cookieLogger = new CookiesLogger_1.CookiesLogger();
            this.cookieLogger.startAction();
        };
        ContainerView.prototype.sendCookieLoggerAction = function () {
            if (!this.cookieLogger) {
                this.setupCookieLogger();
            }
            this.cookieLogger.endAction();
            this.cookieLogger = null;
        };
        ContainerView.prototype.openCookieSettings = function () {
            jQuery('#cookieconsentModal').modal({
                backdrop: false,
                keyboard: false,
                focus: true
            });
            this.hideOverlayBanner();
        };
        ContainerView.prototype.saveSettings = function () {
            this.setCookies({
                ANALYTICS: this.model.analyticsCookie,
                PERFORMANCE: true,
                THIRDPARTIES: this.model.thirdPartiesCookie
            });
        };
        ContainerView.prototype.hideBackDrop = function () {
            this.$('#cookieConsentBackdrop').addClass('hide');
        };
        ContainerView.prototype.showBackDrop = function () {
            this.$('#cookieConsentBackdrop').removeClass('hide');
        };
        ContainerView.prototype.acceptAllCookies = function () {
            this.setCookies({
                ANALYTICS: true,
                PERFORMANCE: true,
                THIRDPARTIES: true
            });
        };
        ContainerView.prototype.rejectAllCookies = function () {
            this.setCookies({
                ANALYTICS: false,
                PERFORMANCE: true,
                THIRDPARTIES: false
            });
        };
        ContainerView.prototype.getContext = function () {
            return {
                overlayColor: Configuration_1.Configuration.overlayColor
            };
        };
        ContainerView.prototype.setupNavigationListener = function () {
            var _this = this;
            Backbone_1.history.on('route', function () {
                _this.rebuildOverlayView();
            });
        };
        ContainerView.prototype.rebuildOverlayView = function () {
            if (!CookiesHandler_1.CookiesHandler.getCookies() && !Utils_1.Utils.isTheCookiePolicyPageOpen()) {
                this.overlayView = new Overlay_View_1.OverlayView({ container: this.application });
                this.showBackDrop();
            }
            else {
                if (this.overlayView) {
                    this.overlayView.removeTrapFocus();
                }
                this.overlayView = null;
            }
            this.render();
        };
        ContainerView.prototype.hideOverlayBanner = function () {
            var cookieConsentOverlayView = this.getChildViewInstance('cookieConsent-overlay');
            if (cookieConsentOverlayView) {
                cookieConsentOverlayView.hideOverlayBanner();
                cookieConsentOverlayView.enableFocusOnModal();
            }
        };
        ContainerView.prototype.setCookies = function (cookieOptions) {
            var _this = this;
            var deferred = jQuery.Deferred();
            if (cookieOptions) {
                CookiesHandler_1.CookiesHandler.setCookies(cookieOptions)
                    .done(function () {
                    _this.model.set(cookieOptions);
                    _this.sendCookieLoggerAction();
                    _this.hideBackDrop();
                    _this.closeOverlay();
                    deferred.resolve();
                })
                    .fail(function () {
                    _this.hideBackDrop();
                    _this.closeOverlay();
                    deferred.reject();
                });
            }
            return deferred;
        };
        ContainerView.prototype.closeOverlay = function () {
            var cookieConsentOverlayView = this.getChildViewInstance('cookieConsent-overlay');
            if (cookieConsentOverlayView) {
                cookieConsentOverlayView.closeOverlay();
                this.render();
            }
        };
        return ContainerView;
    }(Backbone_1.View));
    exports.ContainerView = ContainerView;
});
